import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, UserIcon } from 'lucide-react';
import { Container } from './ui/Container';
export function Testimonial() {
  return <section className="py-24 bg-iris-black relative" data-id="element-283">
      <Container data-id="element-284">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-iris-surface border border-iris-border p-10 md:p-16 relative" data-id="element-285">
          <QuoteIcon className="absolute top-8 left-8 w-12 h-12 text-iris-border opacity-50" data-id="element-286" />

          <blockquote className="relative z-10" data-id="element-287">
            <p className="text-2xl md:text-3xl font-display text-white leading-snug mb-8 text-balance" data-id="element-288">
              "Before IRIS, our team spent hours chasing email threads and
              updating shared spreadsheets to track requests. Now we have a
              single source of truth — and complete visibility into our
              operational tempo."
            </p>

            <div className="flex items-center gap-4 border-t border-iris-border pt-6" data-id="element-289">
              <div className="w-12 h-12 bg-iris-black border border-iris-border flex items-center justify-center rounded-full" data-id="element-290">
                <UserIcon className="w-6 h-6 text-iris-muted" data-id="element-291" />
              </div>
              <div data-id="element-292">
                <div className="font-mono text-sm text-white font-bold uppercase tracking-wider" data-id="element-293">
                  Operations Director
                </div>
                <div className="text-sm text-iris-muted" data-id="element-294">
                  State Fusion Center
                </div>
              </div>
            </div>
          </blockquote>

          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-iris-green" data-id="element-295"></div>
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-iris-green" data-id="element-296"></div>
        </motion.div>
      </Container>
    </section>;
}